import {
  AfterViewInit,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  Output,
  SimpleChanges
} from '@angular/core';
import {ChatMessageService} from "../../message.service";

declare let $: any;
declare let iNet: any;

@Component({
  selector: 'group-call-list',
  templateUrl: './group-call-list.component.html',
  styleUrls: ['./group-call-list.component.scss']
})
export class GroupCallListComponent implements OnDestroy, AfterViewInit, OnChanges {

  @Output() roomSelected = new EventEmitter<any>();
  @Input() groupList: any[] | undefined;
  groupCallList: any = [];
  memberList: any[] = [];
  titleListMember: string = '';
  numberListMember: string = '';
  checkIndex: any;

  constructor(
    private messageService: ChatMessageService,
  ) {
    this.loadGroupMessageList();
    this.reloadGroupMessage();
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.groupCallList = this.groupList;
  }

  ngAfterViewInit(): void {
  }

  ngOnDestroy(): void {
  }

  selectRoom(roomName: string | null) {
    this.roomSelected.emit(roomName);
    this.checkIndex = this.groupCallList.indexOf(roomName);
  }

  checkActive(index: any) {
    return index == this.checkIndex
  }

  loadGroupMessageList() {
    this.messageService.getGroupMessageList().subscribe(data => {
      this.groupCallList = data.items || [];
    });
  }

  reloadGroupMessage() {
    this.messageService.onReloadContactList().subscribe(data => {
      if (this.groupCallList.length > data.groupList.length) {
        this.selectRoom(data.groupList[0]);
        this.checkIndex = 0;
        this.checkActive(0);
      } else if (this.groupCallList.length < data.groupList.length) {
        // this.selectRoom(data.groupList[data.groupList.length - 1]);
        this.checkIndex = data.groupList.length - 1;
        this.checkActive(data.groupList.length - 1);
      }
      this.groupCallList = data.groupList || [];
    })
  }

  showNameMemberInGroup(data: any) {
    let username = '';
    for (let i = 0; i < data.length; i++) {
      if (username != '') {
        username = username + ', ' + '\n' + data[i].fullname;
      } else {
        username = data[i].fullname;
      }
    }
    return username;
  }

  shortNameGroup(data: any) {
    // console.log('gg', data.length)
    let result = '';
    if (data.length > 20) {
      result = data.slice(0, 20);
      return result + '...';
    } else {
      return data;
    }
  }
}
